import Candidates from '../Components/Candidates'
function CandidatesPage(){
    return(
        <Candidates/>
    )
}

export default CandidatesPage